import { useAppSelector } from "app/hooks";
import { useAuth } from "hooks/auth";
import { querystring } from "models/Listing";
import { selectCurrentStoreData } from "reduxState/currentStoreData/currentStoreDataSlice";
import useSWR, { SWRResponse } from "swr";
import { Badge, BadgeDetailed } from "types/badges/main";
import { ListingProps, ListResponse } from "types/listing";
import { getEnvVariable } from "utilities/env";

export const useBadges = () => {
  const { code } = useAppSelector(selectCurrentStoreData);
  const { fetcher } = useAuth();

  const useBadgesList = (
    props?: ListingProps,
  ): SWRResponse<ListResponse<BadgeDetailed>> => {
    return useSWR(
      () =>
        code
          ? `${getEnvVariable(
              "REACT_APP_API_URL",
            )}/${code}/badge-type${querystring(props)}`
          : null,
      fetcher,
    );
  };

  const useBadgeDetails = (
    badgeTypeId?: string,
  ): SWRResponse<BadgeDetailed, any> => {
    return useSWR(
      () =>
        badgeTypeId && code
          ? `${getEnvVariable(
              "REACT_APP_API_URL",
            )}/${code}/badge-type/${badgeTypeId}`
          : null,
      fetcher,
    );
  };

  const updateBadge = async (badge: Badge) => {
    const response = await fetcher(
      `${getEnvVariable("REACT_APP_API_URL")}/${code}/badge-type/${badge.id}`,
      {
        body: JSON.stringify({ badgeType: { name: badge.name } }),
        headers: { "Content-Type": "application/json" },
        method: "PUT",
      },
    );
    if (response.status === 204) {
      return true;
    } else {
      throw await response.json();
    }
  };

  return {
    useBadgesList,
    useBadgeDetails,
    updateBadge,
  };
};
